import { FastSinglelist } from "../../../utils/SingletonList";
import { ShaderDefines2D } from "../../../webgl/shader/d2/ShaderDefines2D";
import { WebDefineDatas } from "../../RenderModuleData/WebModuleData/WebDefineDatas";
import { WebGLEngine } from "../RenderDevice/WebGLEngine";
export class WebGLRenderelement2D {
    constructor() {
        this.renderStateIsBySprite = true;
        this._shaderInstances = new FastSinglelist();
    }
    _compileShader(context) {
        var passes = this.subShader._passes;
        this._shaderInstances.clear();
        for (var j = 0, m = passes.length; j < m; j++) {
            var pass = passes[j];
            if (pass.pipelineMode !== context.pipelineMode)
                continue;
            var comDef = WebGLRenderelement2D._compileDefine;
            if (context.sceneData) {
                context.sceneData._defineDatas.cloneTo(comDef);
            }
            else {
                context._globalConfigShaderData.cloneTo(comDef);
            }
            let returnGamma = !(context._destRT) || ((context._destRT)._textures[0].gammaCorrection != 1);
            if (returnGamma) {
                comDef.add(ShaderDefines2D.GAMMASPACE);
            }
            else {
                comDef.remove(ShaderDefines2D.GAMMASPACE);
            }
            if (context.invertY) {
                comDef.add(ShaderDefines2D.INVERTY);
            }
            else {
                comDef.remove(ShaderDefines2D.INVERTY);
            }
            if (this.value2DShaderData) {
                comDef.addDefineDatas(this.value2DShaderData.getDefineData());
                pass.nodeCommonMap = this.nodeCommonMap;
            }
            if (this.materialShaderData)
                comDef.addDefineDatas(this.materialShaderData._defineDatas);
            var shaderIns = pass.withCompile(comDef, true);
            this._shaderInstances.add(shaderIns);
        }
    }
    _prepare(context) {
        this._compileShader(context);
    }
    _render(context) {
        if (this._shaderInstances.length == 1) {
            this.renderByShaderInstance(this._shaderInstances.elements[0], context);
        }
        else {
            var passes = this._shaderInstances.elements;
            for (var j = 0, m = this._shaderInstances.length; j < m; j++) {
                this.renderByShaderInstance(passes[j], context);
            }
        }
    }
    renderByShaderInstance(shader, context) {
        if (!shader.complete)
            return;
        shader.bind();
        this.value2DShaderData && shader.uploadUniforms(shader._sprite2DUniformParamsMap, this.value2DShaderData, true);
        context.sceneData && shader.uploadUniforms(shader._sceneUniformParamsMap, context.sceneData, true);
        this.materialShaderData && shader.uploadUniforms(shader._materialUniformParamsMap, this.materialShaderData, true);
        if (this.renderStateIsBySprite || !this.materialShaderData) {
            shader.uploadRenderStateBlendDepth(this.value2DShaderData);
            shader.uploadRenderStateFrontFace(this.value2DShaderData, false, context.invertY);
        }
        else {
            shader.uploadRenderStateBlendDepth(this.materialShaderData);
            shader.uploadRenderStateFrontFace(this.materialShaderData, false, context.invertY);
        }
        WebGLEngine.instance.getDrawContext().drawGeometryElement(this.geometry);
    }
    destroy() {
    }
}
WebGLRenderelement2D._compileDefine = new WebDefineDatas();
